import { Dialog, Switch, Transition } from "@headlessui/react";
import React, {
  Fragment,
  useRef,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { openContactModal } from "../../actions/profileModalActions";
import { useHistory } from "react-router-dom";

import { StoreContext } from "../../Context/StoreContext";
import { getNotificationSettings } from "../../services/notificationService";
import axios from "../../utils/axios";
import Button from "../../VibehutUI/Button";
import Close from "../../VibehutUI/Icons/Close";
import Loader from "../../VibehutUI/Loader";
import BellFilled from "../Icons/BellFilled";
import Chat from "../Icons/Chat";
import Warning from "../Icons/Warning";
import X from "../Icons/X";
import PopOver from "../../VibehutUI/Popover";
import {
  showLoginModal,
  showNotificationActionModal,
} from "../../actions/uiModalActions";
import { acceptInviteForHostApprovalRoom } from "../../services/rooomService";
import { checkMyRoomSubscription } from "../../utils/utils";
import SubscriptionModal from "../SubscriptionModal";
import SubscriberApprovalQuestionsModal from "./SubscriberApprovalQuestionsModal";
import globals from "../../globals";

const NotificationModal = ({
  isOpen,
  setIsOpen,
  handleSubscribe,
  eventCreated,
  setEventCreated,
  eventStarted,
  setEventStarted,
  joinedRoom,
  userSubscribed,
  setUserSubscribed,
  setJoinedRoom,
  rsvpEvent,
  setRsvpEvent,
  isSubscribing,
  currentSettingFetching,
}) => {
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth: { user: authUser },
  } = state;
  const cancelButtonRef = useRef(null);

  const [showWarning, setShowWarning] = React.useState(false);

  useEffect(() => {
    if (authUser?.token) {
      getNotificationSettings(authUser.token)
        .then((res) => {
          const _notificationSettings = res.data.notificationSettings;
          if (
            !_notificationSettings.email.isEmailVerified &&
            !_notificationSettings.phoneNumber.isPhoneNumberVerified
          ) {
            setShowWarning(true);
          }
        })
        .catch((err) => console.log("NOTIFICATION SETTINGS err:", err));
    }
  }, [isOpen]);

  return (
    <>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-40 inset-0 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={setIsOpen}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 z-30">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-overlay bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white dark:bg-navyGray rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-96 font-ubuntu">
                <div className="bg-white dark:bg-navyGray dark:border-matteGray py-4 px-4 border-b border-frescoWhite">
                  <div className="flex justify-between items-center">
                    <div className="flex flex-row justify-start items-center">
                      <p className="font-medium text-lg text-black dark:text-frescoWhite">
                        Room Notifications
                      </p>
                    </div>
                    <span
                      className="bg-frescoWhite p-9px rounded-full cursor-pointer"
                      onClick={() => {
                        setIsOpen(false);
                      }}
                    >
                      <Close />
                    </span>
                  </div>
                </div>

                <div>
                  <div className="px-4 mt-3">
                    {showWarning && (
                      <div className="flex  p-3 bg-primaryYellow  rounded-2xl">
                        <div className="flex justify-center items-center pr-2">
                          <Warning />
                        </div>
                        <div className="">
                          <p className="text-sm font-normal text-black ">
                            Please add your email or phone number to the
                            “Contact Info” tab to recieve notifications.
                          </p>
                          <p
                            className="text-sm font-bold text-black cursor-pointer underline"
                            onClick={() => {
                              openContactModal(dispatch);
                            }}
                          >
                            View Account
                          </p>
                        </div>
                        <div
                          onClick={() => setShowWarning(false)}
                          className="flex align-item-center cursor-pointer"
                        >
                          <X />
                        </div>
                      </div>
                    )}
                    <div className="py-3 border-b dark:border-matteGray border-frescoWhite">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                          Event Created
                        </p>
                        {currentSettingFetching ? (
                          <Loader />
                        ) : (
                          <Switch
                            checked={eventCreated}
                            onChange={() => setEventCreated(!eventCreated)}
                            className={`${
                              eventCreated ? "bg-primary" : "bg-gray-200"
                            } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                          >
                            <span
                              className={`${
                                eventCreated ? "translate-x-6" : "translate-x-1"
                              } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                            />
                          </Switch>
                        )}
                      </div>
                    </div>
                    <div className="py-3 dark:border-matteGray border-b border-frescoWhite">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                          Event Started
                        </p>
                        {currentSettingFetching ? (
                          <Loader />
                        ) : (
                          <Switch
                            checked={eventStarted}
                            onChange={() => setEventStarted(!eventStarted)}
                            className={`${
                              eventStarted ? "bg-primary" : "bg-gray-200"
                            } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                          >
                            <span
                              className={`${
                                eventStarted ? "translate-x-6" : "translate-x-1"
                              } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                            />
                          </Switch>
                        )}
                      </div>
                    </div>

                    <div className="py-3 dark:border-matteGray border-b border-frescoWhite">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                          Auto RSVP Events
                        </p>

                        {currentSettingFetching ? (
                          <Loader />
                        ) : (
                          <Switch
                            checked={rsvpEvent}
                            onChange={() => setRsvpEvent(!rsvpEvent)}
                            className={`${
                              rsvpEvent ? "bg-primary" : "bg-gray-200"
                            } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                          >
                            <span
                              className={`${
                                rsvpEvent ? "translate-x-6" : "translate-x-1"
                              } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                            />
                          </Switch>
                        )}
                      </div>
                    </div>

                    <div className="py-3 dark:border-matteGray border-b border-frescoWhite">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                          People Joined Room
                        </p>

                        {currentSettingFetching ? (
                          <Loader />
                        ) : (
                          <Switch
                            checked={joinedRoom}
                            onChange={() => setJoinedRoom(!joinedRoom)}
                            className={`${
                              joinedRoom ? "bg-primary" : "bg-gray-200"
                            } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                          >
                            <span
                              className={`${
                                joinedRoom ? "translate-x-6" : "translate-x-1"
                              } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                            />
                          </Switch>
                        )}
                      </div>
                    </div>
                    <div className="py-3 dark:border-matteGray border-b border-frescoWhite">
                      <div className="flex justify-between items-center">
                        <p className="text-sm font-medium text-navyGray dark:text-frescoWhite">
                          User Subscribed
                        </p>

                        {currentSettingFetching ? (
                          <Loader />
                        ) : (
                          <Switch
                            checked={userSubscribed}
                            onChange={() => setUserSubscribed(!userSubscribed)}
                            className={`${
                              userSubscribed ? "bg-primary" : "bg-gray-200"
                            } relative inline-flex items-center  rounded-full h-31px w-51px float-right`}
                          >
                            <span
                              className={`${
                                userSubscribed
                                  ? "translate-x-6"
                                  : "translate-x-1"
                              } inline-block w-27px h-27px transform bg-white shadow rounded-full duration-200`}
                            />
                          </Switch>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className=" px-4 py-3 flex flex-row-reverse ">
                    {isSubscribing ? (
                      <Loader />
                    ) : (
                      <Button
                        size="vibhut-sm"
                        variant="vibhut-primary"
                        onClick={() => {
                          handleSubscribe(
                            false,
                            eventCreated,
                            eventStarted,
                            joinedRoom,
                            userSubscribed,
                            rsvpEvent,
                          );
                        }}
                      >
                        Done
                      </Button>
                    )}
                    <div className="mr-3">
                      <Button
                        size="vibhut-sm"
                        variant="vibhut-secondary"
                        onClick={() => setIsOpen(false)}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

function NotificationUpdate({
  roomId,
  totalSubscribedUsers,
  roomOwner,
  showSubscriptionBell = true,
  showChatIcon = true,
  blockedUsers = [],
  allSubscribers,
  reloadPage = false,
  isSubscriberRequireApproval = false,
  roomSubscriberApprovalStatus = "",
}) {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isSubscribing, setIsSubscribing] = useState(false);
  const [eventCreated, setEventCreated] = useState(false);
  const [eventStarted, setEventStarted] = useState(false);
  const [joinedRoom, setJoinedRoom] = useState(false);
  const [userSubscribed, setUserSubscribed] = useState(false);
  const [rsvpEvent, setRsvpEvent] = useState(false);
  const [currentSettingFetching, setCurrentSettingFetching] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const { state, dispatch } = useContext(StoreContext);
  const [totalUsers, setTotalUsers] = useState(totalSubscribedUsers);
  const [showTooltip, setShowTooltip] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);

  const history = useHistory();
  const {
    auth: { user },
    subscription: { mySubscriptions },
    room: {
      liveRoom: { liveRoom: room },
    },
  } = state;

  useEffect(() => {
    const mySubscription = checkMyRoomSubscription(mySubscriptions, room?._id);
    setSubscriptionData(mySubscription);
  }, [mySubscriptions, room]);

  const { roomHasSubscription, isUserSubscribed } = React.useMemo(() => {
    const roomHasSubscription =
      room?.owner?._id !== undefined &&
      user?._id !== room?.owner?._id &&
      room?.hasSubscription;

    return {
      roomHasSubscription: roomHasSubscription,
      isUserSubscribed:
        roomHasSubscription &&
        ((subscriptionData?.nextRenewal &&
          new Date(subscriptionData?.nextRenewal).getTime() >
            new Date().getTime()) ||
          subscriptionData?.isOneTime),
    };
  }, [
    room?.hasSubscription,
    room?.owner?._id,
    subscriptionData?.nextRenewal,
    user?._id,
    subscriptionData?.isOneTime,
  ]);

  const subscriberRequireApproval = () => {
    if (isSubscriberRequireApproval) {
      if (roomSubscriberApprovalStatus === "Approved") {
        return true;
      }
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (user?.token && roomId) {
      if (allSubscribers) {
        const subscriber = allSubscribers.find((_u) => _u.owner === user?._id);
        if (subscriber) {
          const _isSubscribed = subscriberRequireApproval();
          setIsSubscribed(_isSubscribed);
        }
      } else {
        setCurrentSettingFetching(true);
        axios
          .get(`/notification-subscription/${roomId}`, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            if (res.data.data.notificationSubscription) {
              const { roomNotification, _id } =
                res.data.data.notificationSubscription;
              const _isSubscribed = subscriberRequireApproval();
              setIsSubscribed(_isSubscribed);
              setEventCreated(roomNotification.eventCreated);
              setEventStarted(roomNotification.eventStarted);
              setJoinedRoom(roomNotification.joinedRoom);
              setUserSubscribed(roomNotification.userSubscribed);
              setRsvpEvent(roomNotification.rsvpEvent);
              setSubscriptionId(_id);
            }
            setCurrentSettingFetching(false);
          })
          .catch((err) => {
            console.log(err);
            setCurrentSettingFetching(false);
          });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [room, roomId]);

  const handleSubscribe = useCallback(
    (
      isNew,
      eventCreated,
      eventStarted,
      joinedRoom,
      userSubscribed,
      rsvpEvent,
      isModelOpen = false,
    ) => {
      if (!user?.token) {
        showLoginModal(dispatch);
        return;
      }

      if (room?.isAnswersRequireForApproval) {
        globals.showModal(
          "Subscriber Approval Questions",
          <SubscriberApprovalQuestionsModal />,
        );
        return;
      }

      setIsSubscribing(true);
      axios
        .post(
          `/notification-subscription/room`,
          {
            subscribeRoom: roomId,
            ...(room?.isSubscriberRequireApproval
              ? {
                  isSubscriberRequireApproval:
                    room?.isSubscriberRequireApproval,
                }
              : {}),
            isNewSubscriber: isNew,
            roomNotification: {
              eventCreated,
              eventStarted,
              joinedRoom,
              userSubscribed,
              rsvpEvent,
            },
            sendSubscriptionMessage: isModelOpen ? false : true,
            type: "room",
          },
          {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          },
        )
        .then((res) => {
          if (reloadPage || isSubscriberRequireApproval) {
            window.location.reload();
            return;
          }
          if (res.data.data.notificationSubscription) {
            const { roomNotification, _id } =
              res.data.data.notificationSubscription;
            setIsSubscribing(false);
            setIsSubscribed(true);
            setEventCreated(roomNotification.eventCreated);
            setEventStarted(roomNotification.eventStarted);
            setJoinedRoom(roomNotification.joinedRoom);
            setUserSubscribed(roomNotification.userSubscribed);
            setRsvpEvent(roomNotification.rsvpEvent);
            setSubscriptionId(_id);
            setIsNotificationOpen(isModelOpen);
            setTotalUsers((totalUsers) => totalUsers + 1);
            getNotificationSettings(user.token)
              .then((res) => {
                const _notificationSettings = res.data.notificationSettings;
                if (
                  !_notificationSettings.email.isEmailVerified &&
                  !_notificationSettings.phoneNumber.isPhoneNumberVerified
                ) {
                  showNotificationActionModal(dispatch);
                }
              })
              .catch((err) => console.log("NOTIFICATION SETTINGS err:", err));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [
      user?.token,
      room?.isAnswersRequireForApproval,
      room?.isSubscriberRequireApproval,
      roomId,
      dispatch,
      reloadPage,
      isSubscriberRequireApproval,
    ],
  );
  const handleUnsubscribe = useCallback(() => {
    setIsSubscribing(true);
    axios
      .delete(`/notification-subscription/${subscriptionId}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then(() => {
        if (isSubscriberRequireApproval) {
          window.location.reload();
          return;
        }
        setIsSubscribing(false);
        setIsSubscribed(false);
        setTotalUsers((totalUsers) => totalUsers - 1);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isSubscriberRequireApproval, subscriptionId, user?.token]);

  const handleChatRedirect = useCallback(() => {
    if (blockedUsers?.includes(user?._id)) {
      return;
    }
    dispatch({
      type: "GET_CHAT_ROOM_SUCCESS",
      payload: {
        chatRoom: undefined,
      },
    });
    history.push(`/chat?roomId=${roomId}`);
  }, []);

  const acceptHostInvitation = async () => {
    setIsSubscribing(true);
    await acceptInviteForHostApprovalRoom(user?.token, roomId)
      .then(() => {
        if (isSubscriberRequireApproval) {
          window.location.reload();
          return;
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsSubscribing(false);
      });
  };

  const isMyRoom = !!roomOwner && user?._id === roomOwner;

  const renderButtonWithStatus = useCallback(() => {
    if (isSubscriberRequireApproval) {
      switch (roomSubscriberApprovalStatus) {
        case "Pending":
          return (
            <Button
              size={"vibhut-sm-outline"}
              variant={"vibhut-primary-outline"}
              disabled={true}
            >
              Pending Approval · {totalUsers + 1}
            </Button>
          );
        case "Declined":
          return (
            <Button
              size={"vibhut-sm-outline"}
              variant={"vibhut-disable"}
              disabled={true}
            >
              Declined Approval · {totalUsers + 1}
            </Button>
          );
        case "Invited":
          return (
            <>
              <Button
                size={"vibhut-sm-outline"}
                variant={"vibhut-primary-outline"}
                onClick={() => acceptHostInvitation()}
              >
                Accept Invitation · {totalUsers + 1}
              </Button>
            </>
          );
        default:
          break;
      }
    }
    return (
      <Button
        size={isMyRoom ? "vibhut-sm" : "vibhut-sm-outline"}
        variant={isMyRoom ? "vibhut-disable" : "vibhut-primary-outline"}
        onClick={() => handleSubscribe(true, true, true, true, true)}
        disabled={isMyRoom}
        customClasses={`  ${
          isMyRoom ? "" : "hover:text-white hover:bg-primary"
        } `}
      >
        {isMyRoom
          ? totalUsers + 1 === 1
            ? "Subscriber"
            : "Subscribers"
          : "Subscribe"}{" "}
        · {totalUsers + 1}
      </Button>
    );
  }, [
    handleSubscribe,
    isMyRoom,
    isSubscriberRequireApproval,
    roomSubscriberApprovalStatus,
    totalUsers,
  ]);

  const _renderButton = useCallback(() => {
    if (isSubscribing) {
      return <Loader />;
    }
    if (!currentSettingFetching) {
      if (isMyRoom) {
        return (
          <div className="flex items-center gap-2.5 relative">
            {showChatIcon && (
              <Button
                size="vibhut-sm"
                variant="vibhut-secondary"
                onClick={handleChatRedirect}
                customClasses="flex items-center gap-1"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <Chat ratio="18" />
                <span>Chat</span>
                {showTooltip && blockedUsers?.includes(user?._id) && (
                  <PopOver
                    text="Blocked"
                    leftPosition={"-left-4"}
                    topPosition={"-top-14"}
                    size={28}
                  />
                )}
              </Button>
            )}
            <Button
              size="vibhut-sm"
              variant={"vibhut-disable"}
              disabled={isMyRoom}
              onClick={handleUnsubscribe}
            >
              Subscribed · {totalUsers + 1}
            </Button>
          </div>
        );
      }
      if (roomHasSubscription && !isUserSubscribed) {
        return (
          <Button
            size="vibhut-sm-outline"
            variant="vibhut-primary-outline"
            onClick={() => {
              if (!user) {
                return showLoginModal(dispatch);
              }
              setIsSubscriptionOpen(true);
            }}
          >
            {`Join for $${Number(parseFloat(room?.subscriptionAmount)).toFixed(
              2,
            )}`}
          </Button>
        );
      }
      if (isSubscribed || roomSubscriberApprovalStatus === "Approved") {
        return (
          <div className="flex items-center gap-2.5 relative">
            {showChatIcon && (
              <Button
                size="vibhut-sm"
                variant="vibhut-secondary"
                onClick={handleChatRedirect}
                customClasses="flex items-center gap-1"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              >
                <Chat ratio="18" />
                <span>Chat</span>
                {showTooltip && blockedUsers?.includes(user?._id) && (
                  <PopOver
                    text="Blocked"
                    leftPosition={"-left-4"}
                    topPosition={"-top-14"}
                    size={28}
                  />
                )}
              </Button>
            )}

            <Button
              size="vibhut-sm"
              variant={isMyRoom ? "vibhut-disable" : "vibhut-secondary"}
              disabled={isMyRoom}
              onClick={handleUnsubscribe}
            >
              Subscribed · {totalUsers + 1}
            </Button>
          </div>
        );
      }

      return (
        <div className="flex items-center gap-4">
          {showChatIcon && (
            <>
              {isMyRoom ? (
                <Button
                  size="vibhut-sm"
                  variant="vibhut-secondary"
                  onClick={handleChatRedirect}
                  customClasses="flex items-center gap-1"
                >
                  <Chat ratio="18" />
                  <span>Chat</span>
                </Button>
              ) : (
                <div
                  onMouseEnter={() => setShowTooltip(true)}
                  onMouseLeave={() => setShowTooltip(false)}
                  className={`w-9 h-9
                bg-primaryGray text-navyGray
               rounded-full flex items-center justify-center cursor-pointer relative`}
                >
                  {showTooltip && (
                    <span className="absolute right-12 top-1">
                      <PopOver text="Subscribers only" size="32" />
                    </span>
                  )}
                  <span>
                    <Chat />
                  </span>
                </div>
              )}
            </>
          )}
          {renderButtonWithStatus()}
        </div>
      );
    }
    return <Loader />;
  }, [
    blockedUsers,
    currentSettingFetching,
    dispatch,
    handleChatRedirect,
    handleUnsubscribe,
    isMyRoom,
    isSubscribed,
    isSubscribing,
    isUserSubscribed,
    renderButtonWithStatus,
    room?.subscriptionAmount,
    roomHasSubscription,
    roomSubscriberApprovalStatus,
    showChatIcon,
    showTooltip,
    totalUsers,
    user,
  ]);

  return (
    <>
      {showSubscriptionBell && isSubscribed ? (
        <button
          onClick={() => setIsNotificationOpen(true)}
          className={`w-9 h-9
                bg-frescoWhite text-primary
               rounded-full flex items-center justify-center cursor-pointer`}
        >
          <BellFilled ratio={16} />
        </button>
      ) : undefined}
      {_renderButton()}
      <NotificationModal
        isOpen={isNotificationOpen}
        setIsOpen={setIsNotificationOpen}
        handleSubscribe={handleSubscribe}
        eventCreated={eventCreated}
        setEventCreated={setEventCreated}
        eventStarted={eventStarted}
        setEventStarted={setEventStarted}
        joinedRoom={joinedRoom}
        setJoinedRoom={setJoinedRoom}
        userSubscribed={userSubscribed}
        setUserSubscribed={setUserSubscribed}
        rsvpEvent={rsvpEvent}
        setRsvpEvent={setRsvpEvent}
        isSubscribing={isSubscribing}
        currentSettingFetching={currentSettingFetching}
      />
      {room?.hasSubscription && (
        <SubscriptionModal
          isOpen={isSubscriptionOpen}
          setIsOpen={setIsSubscriptionOpen}
          amount={room?.subscriptionAmount}
          room={room}
          roomOwner={room.owner._id}
          subscriptionData={subscriptionData}
          setSubscriptionData={setSubscriptionData}
          roomName={room?.name}
        />
      )}
    </>
  );
}

export default NotificationUpdate;
